import type { FC } from 'react'
import React from 'react'

import { useContextTranslation } from '@core/i18n'

import { AvatarCircle, AvatarContainer, AvatarName } from './Avatar.styles'

/** Shared Avatar HOC */
export const Avatar: FC = () => {
  const { t } = useContextTranslation()
  return (
    <AvatarContainer>
      <AvatarCircle>
        <AvatarName>{t(`oneToOne:Agent`)}</AvatarName>
      </AvatarCircle>
    </AvatarContainer>
  )
}
